import React from 'react'
import styled from 'styled-components'

interface IProps {
  title: string
  subtitle?: string
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void
}

const DialPadButton = ({ title, subtitle, onClick }: IProps) => {
  return (
    <Div data-value={title} onClick={onClick}>
      <span className="title">{title}</span>
      {subtitle && <span className="subtitle">{subtitle}</span>}
    </Div>
  )
}

const Div = styled.div`
  background-color: ${({ theme }) => theme.colors.grey.lighter};
  width: ${({ theme }) => theme.util.pixelToRem(50)};
  height: ${({ theme }) => theme.util.pixelToRem(50)};
  border-radius: 0.625rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.5rem;
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey.light};
  }

  span.title {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    ${({ theme }) => theme.typography.m.normal};
    color: ${({ theme }) => theme.colors.primary.dark};
  }

  span.subtitle {
    font-weight: ${({ theme }) => theme.fontWeight.normal};
    ${({ theme }) => theme.typography.xxs.normal};
    color: ${({ theme }) => theme.colors.primary.dark};
  }
`

export { DialPadButton }
